import * as React from 'react';
import './label.scss';
import { ReactComponent as CloseSmallIcon } from '../../assets/icons/close_small.svg';

interface Props {
    text: string;
    type: string;
    color_type?: string;
    textColor?: string;
    action?: (() => void);
}

const Label: React.FunctionComponent<Props> = ({ text, type, color_type, action, textColor }) => {
    color_type && document.documentElement.style.setProperty('--bg', color_type);
    textColor && document.documentElement.style.setProperty('--color', textColor);

    if (type === 'type1') {
        return <div className="com-label com-label__type1">{text}</div>;
    } else if (type === 'type2') {
        return <div className={`com-label num label-color__${color_type}`}>{text}</div>;
    } else if (type === 'type3') {
        return <div className={`com-label com-label__type3`}>{text}</div>;
    } else if (type === 'type4') {
        return (
            <div className={`label-type4`}>
                <div>{text}</div>
                <div className='label-type4__close' onClick={action}>
                    <CloseSmallIcon />
                </div>
            </div>
        );
    } else if (type === 'type5') {
        return (
            <div className={`label-type5`}>
                <div>{text}</div>
                <div className='label-type5__close' onClick={action}>
                    <CloseSmallIcon />
                </div>
            </div>
        );
    }else if (type === 'circular') {
        return <div className={`label-${type} label-color__${color_type}`}>{text}</div>;
    } else if (type === 'custom') {
        return <div className={`com-label label-color__custom`}>{text}</div>;
    } else if (type === 'special-note') {
        return <div className={`label-special-notes`}>{text}</div>;
    } else if (type === 'instructions') {
        return <div className={`label-instructions`}>{text}</div>;
    } else {
        return <div>{text}</div>;
    }
};
export default Label;
